/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.1.31",
    versionName: "0.2.0-nightly.2026.1.31",
    versionChannel: "nightly",
    buildDate: "2026-01-31T00:09:35.268Z",
    commitHash: "fac511a8ec3d177ecd504dde96c50b6080d28af6",
};
